import { render, staticRenderFns } from "./yhdista-kayttajatileja.vue?vue&type=template&id=80833906&scoped=true&"
import script from "./yhdista-kayttajatileja.vue?vue&type=script&lang=ts&"
export * from "./yhdista-kayttajatileja.vue?vue&type=script&lang=ts&"
import style0 from "./yhdista-kayttajatileja.vue?vue&type=style&index=0&id=80833906&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80833906",
  null
  
)

export default component.exports